import { render } from "./businessContact.vue?vue&type=template&id=140c5d11&scoped=true"
import script from "./businessContact.vue?vue&type=script&lang=js"
export * from "./businessContact.vue?vue&type=script&lang=js"

import "./businessContact.vue?vue&type=style&index=0&id=140c5d11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140c5d11"]])

export default __exports__